import { render, staticRenderFns } from "./PayrollInfo.vue?vue&type=template&id=e6090b4e&"
import script from "./PayrollInfo.vue?vue&type=script&lang=js&"
export * from "./PayrollInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports